import { alpha, Box, Fade, styled, Typography, useTheme } from "@mui/material";
import clsx from "clsx";
import { hoverStyles } from "helpers/hoverStyles";
import { useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { SideBarItem } from "./sidebarItems";
const PREFIX = "SideBarLinkItem";

const classes = {
	root: `${PREFIX}-root`,
	selected: `${PREFIX}-selected`,
	rod: `${PREFIX}-rod`,
	iconWrapper: `${PREFIX}-iconWrapper`,
	icon: `${PREFIX}-icon`,
};

const StyledLink = styled(Link)(({ theme }) => ({
	[`&.${classes.root}`]: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "0.5rem",
		height: "5rem",
		width: "5rem",
		margin: "0.25rem 0",
		color: "white",
		fontSize: "0.7rem",
		"&:hover": {
			cursor: "pointer",
			textDecoration: "none",
			color: "white",
		},
	},

	[`&.${classes.selected}`]: {
		backgroundColor: alpha(theme.palette.background.default, 0.3),
		color: "white",
		filter: "brightness(100%)",
	},

	[`& .${classes.rod}`]: {
		position: "absolute",
		left: 0,
		height: "2rem",
		width: "0.2rem",
		borderRadius: "0.2rem",
		backgroundColor: "white",
	},

	[`& .${classes.iconWrapper}`]: {
		margin: "0.25rem 0",
		display: "grid",
	},

	[`& .${classes.icon}`]: {
		gridRow: 1,
		gridColumn: 1,
	},
}));

export type SideBarLinkItemProps = SideBarItem;

export const SideBarLinkItem = ({
	route: { path, name },
	icons,
}: SideBarLinkItemProps): JSX.Element => {
	const theme = useTheme();

	const match = useRouteMatch({
		path,
		exact: path === "/",
	});

	const isSelected = match !== null;

	const [isHover, setHover] = useState(false);
	const onMouseEnter = (): void => setHover(true);
	const onMouseLeave = (): void => setHover(false);

	const selectedClass = isSelected && classes.selected;

	return (
		<StyledLink
			to={path}
			style={{ textDecoration: "none" }}
			key={name}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			sx={hoverStyles(theme)}
			className={clsx(classes.root, selectedClass)}
		>
			{/* The rod which indicates if the item is selected */}
			{isSelected && <div className={classes.rod} />}

			<Box display="flex" flexDirection="column" alignItems="center">
				{/* The icon, which is filled when selected or hovering */}
				<div className={classes.iconWrapper}>
					<Fade in={isSelected || isHover} timeout={750}>
						<icons.filled className={classes.icon} />
					</Fade>
					<Fade in={!(isSelected || isHover)} timeout={750}>
						<icons.outlined className={classes.icon} />
					</Fade>
				</div>

				{/* The text */}
				<Typography style={{ fontSize: "0.7rem" }}>{name}</Typography>
			</Box>
		</StyledLink>
	);
};
